import { INestedQuestionSet } from 'Models/BOB/ResponseModels/Life/QuestionSet'

const eiaFormObject: { form_fields: INestedQuestionSet[] } = {
  form_fields: [
    {
      max: undefined,
      name: 'Do you have an existing e-Insurance Account?',
      code: 'existingEIAAccount',
      dropdown: {
        True: 'Yes',
        False: 'No',
      },
      cover_type: 'switch',
      min: undefined,
      description: '',
      input_type: 'Boolean',
      hidden: false,
      values: {
        True: [
          {
            max: undefined,
            name: 'IR Name',
            code: 'nameOfIR',
            dropdown: {},
            cover_type: 'dropdown',
            min: undefined,
            description: '',
            input_type: 'String',
            hidden: false,
            range: false,
            values: {},
          },
          {
            max: undefined,
            // is_required:true,
            name: 'IR Number',
            code: 'irNumber',
            dropdown: undefined,
            regex: /^\d+$/,
            cover_type: 'Text',
            min: undefined,
            description: '',
            input_type: 'String',
            hidden: false,
            range: false,
            values: {},
          },
        ],
        False: [
          {
            max: undefined,
            name: 'Would you like to apply for an e-Insurance Account?',
            code: 'likeToApply',
            dropdown: {
              True: 'Yes',
              False: 'No',
            },
            cover_type: 'switch',
            min: undefined,
            description: '',
            input_type: 'Boolean',
            hidden: false,
            values: {
              True: [
                {
                  max: undefined,
                  name: 'Please choose repository from below:',
                  code: 'nameOfIRToOpen',
                  dropdown: {},
                  cover_type: 'dropdown',
                  min: undefined,
                  description: '',
                  input_type: 'String',
                  hidden: false,
                  values: {},
                },
              ],
              False: [],
            },
          },
        ],
      },
    },
  ],
}
export { eiaFormObject }
